import React from 'react';
import '../../../less/index.less';
import '../less/frp.less';
import hero_img from '../img/hero_img.svg';
import Hero from '../../../../../../../auxiliary-components/shared/HeroBlock';
import InfoBlock from '../../../../../../../auxiliary-components/shared/InfoBlock';
import BusinessOrder from '../../../../../../BusinessOrder';
import hero_data from '../enums/hero_data.json';
import DOMPurify from 'utils/sanitize';
import energocredit_img_1 from '../img/energocredit_img_1.png';
import energocredit_img_2_desktop from '../img/energocredit_img_2_desktop.png';
import energocredit_img_2_mob from '../img/energocredit_img_2_mob.png';
import { energoCreditLink, govFrpConditionsLink } from "../../../../../../../services/urls/urls";
import abank_logo from '../img/abank_logo.png';
import energocredit_logo from '../img/energocredit_logo.png';
import nur_logo from '../img/nur_logo.png';
import kabmin_logo from '../img/kabmin_logo.png';
import serviceUsageItems from '../enums/service_usage_items.json';
import AdditionalProduct from './../../../../../../../auxiliary-components/shared/AdditionalProductBlock';
import additional_cards from '../enums/additional_cards_data.json';
import { getUrl } from "utils/corploansUrl";
import FilesForDownloadNew from '../../../../../../../auxiliary-components/shared/FilesForDownloadNew';
import { getSafeLinkProps } from '../../../../../../../helpers/utils/urlSecurity';

export default function template() {
    const page = 'business-gov-frp';

    const energocredit_img_2 = this.state.isMobile ? energocredit_img_2_mob : energocredit_img_2_desktop;

    const universalWidget = this.widgetsHelper.getWidget.call(this, 'universal_element');
    const universalWidgetData = universalWidget && universalWidget.data;

    const handlersMap = {
      toggleHeroModal: () => this.toggleModal(),
      corploansDefaultLink: getUrl(),
      corploansLoanlineLink: getUrl('loanline'),
      tariffsLink: universalWidgetData && universalWidgetData[0] && universalWidgetData[0].attached_file_url,
      tariffsLineLink: universalWidgetData && universalWidgetData[1] && universalWidgetData[1].attached_file_url,
    };

    const heroData = {
      ...hero_data,
      link: {
        ...hero_data.link,
        onClick: handlersMap[hero_data.link.onClick],
      },
    };

    const additionalCards = additional_cards.map(item => ({
      ...item,
      link: handlersMap[item.link],
      link2: handlersMap[item.link2],
      loading2: this.state.loader
    }));

    return (
      <div className="business-gov-frp">
        <Hero
          data={heroData}
          img={hero_img}
          svg
          page={page}
          className="gov-programs"
        />
        <div className="content">
          <div className="we-support-row">
            <div className="container">
              <h2 className="we-support-row__title">{this.l10n('BUSINESS_GOV_FRP_NEW_WE_SUPPORT_TITLE')}</h2>
              <div className="we-support-row__body">
                <div className="we-support-row__left">
                  <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n('BUSINESS_GOV_FRP_NEW_WE_SUPPORT_TEXT_01'))}}></p>
                  <p>{this.l10n('BUSINESS_GOV_FRP_NEW_WE_SUPPORT_TEXT_02')}</p>
                  <p>{this.l10n('BUSINESS_GOV_FRP_NEW_WE_SUPPORT_TEXT_03')}</p>
                </div>
                <InfoBlock 
                  text={'BUSINESS_GOV_FRP_NEW_INFO_TEXT'}
                />
              </div>
            </div>
          </div>
          <div>
            <div className="service-usage">
              <div className="container">
                <h2 className="service-usage__title">{this.l10n('BUSINESS_GOV_FRP_NEW_SERVICE_USAGE_TITLE')}</h2>
                <div className="service-usage__body">
                  {serviceUsageItems.map((item, index) => (
                    <div key={index} className="service-usage__item item-service-usage">
                      <div className="item-service-usage__title">{this.l10n(item.title)}</div>
                      <div className="item-service-usage__text">
                        {item.link && (
                          <a href={govFrpConditionsLink} target="_blank" rel="noopener noreferrer">
                            {this.l10n(item.link)}
                          </a>
                        )}
                        {item.text && this.l10n(item.text)}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="standarts-block">
              <div className="container">
                <div className="standarts-block__body">
                  <div className="standarts-block__text">
                    <p>{this.l10n('BUSINESS_GOV_FRP_NEW_STANDARTS_BLOCK_TEXT_01')}</p>
                    <p><b>{this.l10n('BUSINESS_GOV_FRP_NEW_STANDARTS_BLOCK_TEXT_02')}</b> {this.l10n('BUSINESS_GOV_FRP_NEW_STANDARTS_BLOCK_TEXT_03')}</p>
                  </div>
                  <a className="standarts-block__btn" {...getSafeLinkProps('/static/business/gov_frp_exclusion_list.pdf')}>
                    {this.l10n('BUSINESS_GOV_FRP_NEW_STANDARTS_BLOCK_BTN')}
                  </a>
                  <div className="standarts-block__text">
                    <p>
                      {this.l10n('BUSINESS_GOV_FRP_NEW_STANDARTS_BLOCK_TEXT_04')} <b>{this.l10n('BUSINESS_GOV_FRP_NEW_STANDARTS_BLOCK_TEXT_05')}</b> <a href={`mailto:${this.l10n('BUSINESS_GOV_FRP_NEW_STANDARTS_BLOCK_LINK')}`}> <br/>{this.l10n('BUSINESS_GOV_FRP_NEW_STANDARTS_BLOCK_LINK')}</a>
                    </p>
                  </div>
                  <FilesForDownloadNew
                    widget={this.widgetsHelper.getWidgetFrom.call(this, 'widgets_2', 'files_to_download')}
                    loader={this.state.widgets_2_loading}
                    noTitle
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="energocredit">
            <div className="container">
              <div className="energocredit__body">
                <div className="energocredit__left">
                  <h2 className="energocredit__title">{this.l10n('BUSINESS_GOV_FRP_ENERGOCREDIT_TITLE')}</h2>
                  <div className="energocredit__text">{this.l10n('BUSINESS_GOV_FRP_ENERGOCREDIT_TEXT')}</div>
                  <div className="energocredit__conditions conditions-energocredit">
                    <div className="conditions-energocredit__item">
                      <div className="conditions-energocredit__title">{this.l10n('BUSINESS_GOV_FRP_ENERGOCREDIT_CONDITIONS_1_TITLE')}</div>
                      <div className="conditions-energocredit__text">{this.l10n('BUSINESS_GOV_FRP_ENERGOCREDIT_CONDITIONS_1_TEXT')}</div>
                    </div>
                    <div className="conditions-energocredit__item">
                      <div className="conditions-energocredit__title">{this.l10n('BUSINESS_GOV_FRP_ENERGOCREDIT_CONDITIONS_2_TITLE')}</div>
                      <div className="conditions-energocredit__text" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n('BUSINESS_GOV_FRP_ENERGOCREDIT_CONDITIONS_2_TEXT'))}}></div>
                    </div>
                    <div className="conditions-energocredit__item">
                      <div className="conditions-energocredit__title">{this.l10n('BUSINESS_GOV_FRP_ENERGOCREDIT_CONDITIONS_3_TITLE')}</div>
                      <div className="conditions-energocredit__text">{this.l10n('BUSINESS_GOV_FRP_ENERGOCREDIT_CONDITIONS_3_TEXT')}</div>
                    </div>
                  </div>
                  <a className="energocredit__btn" href={energoCreditLink} target="_blank" rel="noopener noreferrer">{this.l10n('BUSINESS_GOV_FRP_ENERGOCREDIT_BTN')}</a>
                </div>
                <div className="energocredit__right">
                  <img className="energocredit__img" src={kabmin_logo} alt="kabmin" />
                  <img className="energocredit__img" src={energocredit_logo} alt="energocredit" />
                  <div className="energocredit__bottom-logos">
                    <img className="energocredit__img energocredit__img_nur" src={nur_logo} alt="nur" />
                    <img className="energocredit__img energocredit__img_abank" src={abank_logo} alt="abank" />
                  </div>
                </div>
                <img className="energocredit__bg energocredit__bg_1" src={energocredit_img_1} alt="energocredit img 1" />
                <img className="energocredit__bg energocredit__bg_2" src={energocredit_img_2} alt="energocredit img 2" />
              </div>
            </div>
          </div>
          <AdditionalProduct
            items={additionalCards}
            title={'BUSINESS_GOV_FRP_NEW_ADDITIONAL_PRODUCT_TITLE'}
            page={page}
          />
          <FilesForDownloadNew
            widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}
            loader={this.state.loader}
          />
        </div>
        {this.state.showModal && <BusinessOrder attribute="frp" closeModal={() => this.toggleModal()} />}
      </div>
    );
}
